export abstract class StorageService {
  abstract clear(): void;
  abstract getItem<T>(name: string, defaultValue?: T): T;
  abstract setItem(name: string, value: any): void;
  abstract removeItem(name: string): void;
}
